import React from 'react';
import OfflineLayer from '../components/OfflineLayer';

const OfflinePage = () => {
  return (
    <>
      <OfflineLayer />
    </>
  );
};

export default OfflinePage;
